import { openModal, closeModal } from "./modal.js";

const menu = document.querySelector("#main-navigation");
const inner = menu.querySelector(".inner");
const hamburger = document.querySelectorAll(".hamburger");

// Toggle nav
hamburger.forEach((el) =>
  el.addEventListener("click", (e) => {
    menu.classList.contains("hidden") ? openNav() : closeNav();
  }),
);

const searchToggle = document.querySelector(".search-toggle");

searchToggle.addEventListener("click", (e) => {
  const search = document.querySelector(".search-container");
  const icon = searchToggle.querySelectorAll("svg");

  icon.forEach((el) => {
    el.classList.toggle("hidden");
  });

  search.classList.toggle("nav:hidden");

  if (!search.classList.contains("nav:hidden")) {
    // open
    openModal();
    search.querySelector("input").focus();
  } else {
    // closed
    closeModal();
  }
});

const subnavToggle = document.querySelectorAll(".subnavToggle");

subnavToggle.forEach((el) =>
  el.addEventListener("click", (e) => {
    const subnav = el.nextElementSibling;

    if (window.innerWidth < 820) {
      e.preventDefault();
      subnav.classList.contains("hide") ? openSubnav(subnav) : closeSubnav();
    }
  }),
);

const openSubnav = (subnav) => {
  closeSubnav();
  subnav.classList.remove("hide");
};

const closeSubnav = () => {
  document
    .querySelectorAll(".subnav")
    .forEach((el) => el.classList.add("hide"));
};

const openNav = () => {
  openModal();
  menu.classList.remove("hidden");
  inner.classList.add("header-animate");
};

const closeNav = () => {
  closeModal();
  closeSubnav();
  menu.classList.add("hidden");
  inner.classList.remove("header-animate");
};
